// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3n6-n","selects":"Documents_selects__3wH4A"};